import axios from "axios";
import { ApiUtility } from "../Utilities/ApiUtility.axios";

class BiometricStatsService {
  route = `/API/BiometricStats`;

  getBiometricStats = (
    practiceId: number,
    start: number = 0,
    length: number = 15,
    search: string = "",
    fromDate?: string,
    toDate?: string,
    sortCol?: string,
    sortDir?: string
  ) => {
    return ApiUtility.get(`${this.route}`, {
      practiceId,
      start,
      length,
      search,
      fromDate,
      toDate,
      sortCol,
      sortDir,
    });
  };

 getBiometricStatsDownload = (
  practiceId: number,
  search: string = "",
  fromDate?: string,
  toDate?: string,
  sortCol?: string,
  sortDir?: string
) => {
  return ApiUtility.downloadFile(`${this.route}`, {
    practiceId,
    search,
    fromDate,
    toDate,
    sortCol,
    sortDir,
    isDownload: true,
  });
};
}

export default new BiometricStatsService();